export const THREE_MINUTES = 180;
export const TEN_MINUTES = 600;

export const DEFAULT_COUNTDOWN_SECONDS = 5;
export const SUCCESS_COUNTDOWN_SECONDS = 2;
